import React from "react";
import { Col, Row, Input, Modal, Form, Radio, Alert } from 'antd';
import { URL_DELIVERY, URL_INFLORESCENCE } from "../constants/urls";
import { PATCH } from "../frameworks/HttpClient";
import * as _ from 'lodash'
import QRCodeSelect from "../components/common/QRCodeSelect";

export default function EvaluatePollenModal(props) {
  const { open, onClose, target, shippingData, onUpdate } = props;
  const isNoTarget = (target && target === 'add')
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [speciesName, setSpeciesName] = React.useState(null);
  const [form] = Form.useForm();
  const InflorescenceWatch = Form.useWatch('Inflorescence', form);
  const isQCPassedWatch = Form.useWatch('is_qc_passed', form);

  const handleSave = async() => {
    setErrorMessages(null)
    try {
      let data = await form.validateFields();
      await PATCH(`${URL_DELIVERY.INFLORESCENCE_INFLORESCENCE}${form.getFieldValue('Inflorescence')}/`, data)
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  React.useEffect(() => {
    if(open){
      form.resetFields();
    } else {
      setErrorMessages(null)
      setSpeciesName(null);
    }
  },[open])

  React.useEffect(() => {
    if (!isNoTarget) {
      if (target) {
        form.setFieldValue('Inflorescence', target && target.inflorescence)
        setSpeciesName(target.inflorescence_species_name)
        if (target.is_qc_passed === null)
          form.setFieldValue('is_qc_passed', true)
      }
    }
  },[isNoTarget])

  React.useEffect(() => {
    if (InflorescenceWatch) 
      form.setFieldValue('is_qc_passed', true);

  }, [InflorescenceWatch])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={'รับช่อ'}
      okText={'รับเข้า'}
      cancelText={'ยกเลิก'}
      width={600}
      maskClosable={false}
      onOk={handleSave} >

      {!errorMessages && speciesName && 
        <Alert
          message={speciesName}
          type="success"
          showIcon
          style={{marginBottom: "12px", textAlign: "left"}}
        />
      }

      {errorMessages && 
        <Alert
          message={errorMessages}
          type="error"
          showIcon
          style={{marginBottom: "12px", textAlign: "left"}}
        />
      }

      <Form
        form={form}
        layout="vertical" >
        <Row gutter ={16}>
          <Col md={12} sm={24} xs={24}>
            <Form.Item
              name="Inflorescence"
              label="รหัสช่อ"
              rules={[{ required: true}]}>
              <QRCodeSelect
                fetchUrl={URL_INFLORESCENCE.INFLORESCENCE}
                fetchParams={{ 
                  is_active: true,
                  delivery_transaction : shippingData ? shippingData.id : "none",
                  page_size: 999
                }}
                optionLabel={'code'}
                placeholder='เลือกช่อ'
                disabled={isNoTarget ? false : true}
                onChange={(_, value) => {
                  setSpeciesName(value.species_name);
                }}/>
            </Form.Item>
          </Col>

          <Col md={24} sm={24} xs={24} style={{ padding : 12}}>
            <Form.Item
              name='is_qc_passed'
              label='ผลการประเมิน'
              rules={[{ required: true }]}>
            <Radio.Group>
              <Radio value={true} style={{color: "green"}}>ผ่าน</Radio>
              <Radio value={false} style={{color: "red"}}>ไม่ผ่าน</Radio>
            </Radio.Group>
            </Form.Item>
          </Col>

          <Col md={24} sm={24} xs={24}>
            <Form.Item
              name='note'
              label='หมายเหตุ'
              rules={[{ required: isQCPassedWatch ? false : true }]}>
              <Input.TextArea />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}